import React from "react";
import { IoClose } from "react-icons/io5";
import { Editor } from "@monaco-editor/react";

const UserCodeResponse = ({ code }: any) => {
	const [modalIsOpen, setIsOpen] = React.useState(false);

	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	return (
		<div className="">
			<div className="flex gap-x-2 mt-2">
				<div className="text-gray-700 font-medium ">User Code:</div>
				<button
					onClick={openModal}
					className="text-indigo-600 font-medium hover:underline focus:outline-none transition-transform transform hover:scale-105"
				>
					See Response
				</button>
			</div>
			{modalIsOpen && (
				<div
					className={`  fixed inset-0 bg-gray-800 bg-opacity-60 flex justify-center items-center z-10`}
				>
					<div className="relative bg-white dark:bg-zinc-800 rounded-xl shadow-lg p-6 w-[600px] max-w-4xl h-[85vh] overflow-y-auto">
						<div className="flex flex-col h-full">
							{/* Header Section */}
							<div className="flex justify-between items-center mb-4 border-b pb-2">
								<h2 className="text-lg font-semibold text-gray-800">
									Code Response
								</h2>
								<button
									onClick={closeModal}
									className="p-2 rounded-full bg-red-500 text-white font-medium shadow hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-red-300 transition-transform transform hover:scale-110"
									aria-label="Close Modal"
								>
									<IoClose size={20} />
								</button>
							</div>

							{/* Code Editor Section */}
							<div className="flex-1 mt-4 rounded-lg border border-gray-300 shadow-inner overflow-hidden">
								<Editor
									className="h-full"
									height="100%"
									width="100%"
									value={code.code}
									options={{
										contextmenu: false,
										readOnly: true,
										minimap: { enabled: false },
									}}
								/>
							</div>

							{/* Footer */}
							<div className="mt-4 flex justify-end">
								<button
									onClick={closeModal}
									className="px-6 py-2 rounded bg-blue-500 text-white font-medium shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 transition-transform transform hover:scale-105"
								>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default UserCodeResponse;
